var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertIcon, Badge, Button, Divider, Flex, Input, Text, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, InputControl, ModalBase } from '@/components';
import { useToast } from '@/hooks';
import TestingService from '@/services/testing.service';
import { useTools } from '../context/ToolsContext';
export const ModalBlink = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const { fetchStatus, info } = useTools();
    const [datetime, setDatetime] = useState('');
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const payload = {
            target: new Date(datetime).toISOString()
        };
        try {
            const response = yield TestingService.putTimeWarpBlink(payload);
            yield fetchStatus();
            showToast({
                message: response.message,
                status: 'success'
            });
            onClose();
        }
        catch (err) {
            console.error('Failed to blink datetime:', err);
        }
    });
    return (_jsx(ModalBase, Object.assign({ icon: 'calendar-blink', isOpen: isOpen, onClose: onClose, size: 'xl', subtitle: t('page:tool.time-warp.blink.modal-subtitle'), title: t('page:tool.time-warp.blink.title') }, { children: _jsxs(VStack, Object.assign({ spacing: '6' }, { children: [_jsxs(Alert, Object.assign({ status: 'info', textAlign: 'left' }, { children: [_jsx(AlertIcon, {}), _jsx(Text, { children: t('page:tool.time-warp.blink.modal-note') })] })), _jsx(Badge, Object.assign({ p: '2', size: 'lg', textAlign: 'center', w: '100%' }, { children: _jsxs(Flex, Object.assign({ align: 'center', gap: '2' }, { children: [_jsx(Icon, { name: 'pin', p: '1.5', size: '20px' }), info.timeZone] })) })), _jsx(Divider, {}), _jsx(InputControl, Object.assign({ isRequired: true, label: 'Trigger events scheduled for:' }, { children: _jsx(Input, { onChange: (e) => setDatetime(e.target.value), type: 'datetime-local', value: datetime }) })), _jsx(Button, Object.assign({ disabled: !datetime, onClick: handleSubmit, size: 'lg', variant: 'success', w: '100%' }, { children: "Go!" }))] })) })));
};
